import {Component, Input} from '@angular/core';
import {PlanningMachineCreelChange} from '@domain/planning/carpet/planning-machine-creel-change';
import {PlanningItemType} from '@domain/planning/planning-item-type.enum';
import {PlanningMachineMaintenance} from '@domain/planning/planning-machine-maintenance';
import {PlanningMachineUnavailability} from '@domain/planning/planning-machine-unavailability';
import {kebabCase} from 'lodash-es';

@Component({
  selector: 'app-planning-inactivitiy-card',
  templateUrl: './planning-inactivitiy-card.component.html',
  styleUrls: ['./planning-inactivitiy-card.component.scss']
})
export class PlanningInactivitiyCardComponent {
  @Input() public isCompleted: boolean;
  @Input() public planningItem: PlanningMachineMaintenance | PlanningMachineCreelChange | PlanningMachineUnavailability;

  public getIconName(): string {
    return `${kebabCase(PlanningItemType[this.planningItem.type])}`;
  }
}
